import {ADMIN_SERVICE_TYPE} from "../constants";

export const SERVICE_ACTION_TYPE = {
    SET_SERVICE: 'SET_SERVICE',
    SET_ADMIN_COLOR: 'SET_ADMIN_COLOR',
    SET_FILTER_STYLE: 'SET_FILTER_STYLE',
    SET_SERVICE_TEXT_PLURAL: 'SET_SERVICE_TEXT_PLURAL',
    SET_RESPONSES_TEXT_WRT_SERVICE: 'SET_RESPONSES_TEXT_WRT_SERVICE',
    SET_REPORT_ADMIN_COLOR: 'SET_REPORT_ADMIN_COLOR'
}
const initialState = {
    service: localStorage?.getItem('service') ? localStorage?.getItem('service') : 'Form',
    adminColor: (localStorage?.getItem('service') ? localStorage?.getItem('service') : 'Form') === ADMIN_SERVICE_TYPE.QUIZ ? "#329d58" : "#1976d2",
    serviceTextPlural: (localStorage?.getItem('service') ? localStorage?.getItem('service') : 'Form') === ADMIN_SERVICE_TYPE.QUIZ ? "Quizzes" : "Forms",
    responsesTextWRTService: (localStorage?.getItem('service') ? localStorage?.getItem('service') : 'Form') === ADMIN_SERVICE_TYPE.QUIZ ? "Answers" : "Responses",
    filterStyleForPanelColorChange: (localStorage?.getItem('service') ? localStorage?.getItem('service') : 'Form') === ADMIN_SERVICE_TYPE.QUIZ ? 'hue-rotate(300deg)' : null,
    reportAdminColor: '1976d2'
}

const serviceReducer = (state = initialState, action) => {
    switch (action.type) {
        case (SERVICE_ACTION_TYPE.SET_SERVICE):
            return {
                ...state,
                service: action.payload
            }
        case (SERVICE_ACTION_TYPE.SET_FILTER_STYLE):
            return {
                ...state,
                filterStyleForPanelColorChange: action.payload
            }
        case (SERVICE_ACTION_TYPE.SET_SERVICE_TEXT_PLURAL):
            return {
                ...state,
                serviceTextPlural: action.payload
            }
        case (SERVICE_ACTION_TYPE.SET_RESPONSES_TEXT_WRT_SERVICE):
            return {
                ...state,
                responsesTextWRTService: action.payload
            }
        case (SERVICE_ACTION_TYPE.SET_ADMIN_COLOR):
            return {
                ...state,
                adminColor: action.payload
            }
        case (SERVICE_ACTION_TYPE.SET_REPORT_ADMIN_COLOR) :
            return {
                ...state,
                reportAdminColor: action.payload
            }
        default:
            return state
    }
}

export default serviceReducer